import React from 'react';
import { CheckCircle, CheckCircle2, Loader2 } from 'lucide-react';
import { InterventionCard } from './InterventionCard';

export const StepChooseInterventions = ({
  selectedKPI,
  selectedTemplate,
  selectedInterventions,
  interventions,
  loading,
  handleInterventionToggle,
  setConfiguringIntervention,
  setSelectedInterventions
}) => {
  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Recommended Interventions for "{selectedKPI?.name}"
      </h2>
      <p className="text-gray-600 mb-4">
        Select one or more learning interventions ranked by alignment to your KPI.
      </p>
      
      {/* Template Pre-Selection Notice */}
      {selectedTemplate && Object.keys(selectedInterventions).length > 0 && (
        <div className="mb-6 p-4 bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-emerald-100 rounded-lg">
              <CheckCircle2 className="text-emerald-600" size={20} />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">
                Interventions Pre-Selected from Template
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                The <span className="font-medium">"{selectedTemplate.name}"</span> template has pre-selected {Object.keys(selectedInterventions).length} intervention(s) 
                based on best practices for this scenario. You can review, modify, or add more interventions below.
              </p>
              <div className="flex flex-wrap gap-2 mt-3">
                {Object.keys(selectedInterventions).map(intId => {
                  const int = interventions.find(i => i.id === intId);
                  return int ? (
                    <span key={intId} className="text-xs bg-white px-2 py-1 rounded-full text-emerald-700 border border-emerald-200 flex items-center gap-1">
                      <CheckCircle size={12} />
                      {int.name}
                    </span>
                  ) : null;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
      
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="animate-spin text-blue-600" size={32} />
        </div>
      ) : (
        <div className="space-y-3">
          {interventions.map(intervention => (
            <InterventionCard
              key={intervention.id}
              intervention={{
                ...intervention,
                customCost: selectedInterventions[intervention.id]?.customCost,
                customDays: selectedInterventions[intervention.id]?.customDays
              }}
              selected={!!selectedInterventions[intervention.id]}
              onSelect={handleInterventionToggle}
              onConfigure={setConfiguringIntervention}
              selectedKPI={selectedKPI}
              onUpdateCost={(id, cost, days) => {
                setSelectedInterventions(prev => ({
                  ...prev,
                  [id]: {
                    ...prev[id],
                    customCost: cost,
                    customDays: days
                  }
                }));
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};
